class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.querySelector("[data-cart-drawer]");
    this.activeClass = "cart-drawer-is-open";
    this.cartIconBubble = document.querySelector("cart-icon-bubble");

    this.closeButtons = this.querySelectorAll("[data-cart-button-close]");
    this.closeButtons.forEach((btn) =>
      btn.addEventListener("click", this.close.bind(this))
    );

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.drawer.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
  }

  open() {
    document.body.classList.add(this.activeClass);
    document.body.classList.remove("search--is-active");
    document
      .querySelector(".header")
      .classList.remove("header__search--is-active");

    this.cartIconBubble.toggleButton.setAttribute("aria-expanded", true);

    this.drawer.focus();
    trapFocus(this.drawer);
    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    document.body.classList.remove(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute("aria-expanded", false);

    document.body.removeEventListener("click", this.onBodyClick);
    removeTrapFocus();
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      if (section?.selector) {
        const selector = document.querySelector(section.selector);
        if (selector) {
          selector.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }
      }
    });

    // Re-bind the close drawer buttons
    this.querySelectorAll("[data-cart-button-close]").forEach((btn) =>
      btn.addEventListener("click", this.close.bind(this))
    );

    // Re-bind quantity inputs to ensure free product sync
    const quantityInputs = document.querySelectorAll('[name="updates[]"]');
    quantityInputs.forEach((input) => {
      input.addEventListener("change", (event) => {
        const line = event.target.dataset.index;
        const quantity = event.target.value;
        const name = event.target.getAttribute("name");

        // Find the cart-items component and trigger the update
        const cartItems = document.querySelector("cart-items");
        if (cartItems) {
          cartItems.updateQuantity(event.target, line, quantity, name);
        }
      });
    });
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        section: "cart-drawer",
        selector: "[data-cart-drawer]",
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.drawer && !target.closest("cart-drawer")) {
      this.close();
    }
  }
}

if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}
